(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/self-exclusion-24.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/self-exclusion-24.js');
'use strict';

const Button = svs.ui.ReactButton;
const {
  useAtom
} = jotai;
const {
  Form
} = svs.ui.ReactForm;
const {
  activeExclusionsAtom
} = svs.selfExclusion.store.selfExclusionAtoms;
const SelfExclusion24 = () => {
  const [, setActiveExclusions] = useAtom(activeExclusionsAtom);
  const confirmSelfExclusion24 = e => {
    e.preventDefault();
    svs.accountservices.pause24.show(activeExclusions => {
      setActiveExclusions(svs.accountservices.player_exclusions.utils.asArray(activeExclusions));
    });
  };
  return React.createElement(React.Fragment, null, React.createElement("section", {
    className: "exclusion-pause-wrapper padding-xs-h-1 padding-xs-bottom-2",
    id: "self-exclusion-24"
  }, React.createElement(Form, {
    onSubmit: confirmSelfExclusion24
  }, React.createElement("div", null, React.createElement("h2", {
    className: "align-center f-700 f-bold"
  }, "Spelpaus i 24 timmar"), React.createElement("p", null, "Genom att aktivera spelpausen nedan tar du en paus fr\xE5n alla v\xE5ra spel i 24 timmar.")), React.createElement(Button, {
    block: true,
    inverted: true,
    size: 300,
    type: "submit"
  }, "Aktivera spelpaus 24"))), React.createElement("hr", {
    "aria-hidden": true,
    className: "exclusion-border-bottom"
  }));
};
svs.selfExclusion.components.SelfExclusion24 = SelfExclusion24;

 })(window);